<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-10 13:06:31
-->
<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'pushMessageTopic'"
      :headers="headers"
      :hideAddBtn="!hasBtn('add-push-message-topic')"
      pageName="addMessageTopic"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="['topic_name', 'topic_description']"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.topic_name="{ item }">
        <span>{{ INT(item.topic_name) }}</span>
      </template>
      <template #item.topic_description="{ item }">
        <span>{{ INT(item.topic_description) }}</span>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-push-message-topic',
                'edit-push-message-topic',
                'delete-push-message-topic',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  getMessageTopicList,
  deleteMessageTopicDetail,
} from "@/service/api/pushMessageTopic";
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      disabled: true,
      list: {},
      dialog: false,
      options: {
        pagesize: 5, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
        selectlist: [10, 20, 50, 100, 200],
        pagetext: this.$t("label_Each_page_shows"),
      },
      loading: false,
      desserts: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_Topic_name"),
          align: "start",
          value: "topic_name",
          sortable: false,
        },
        {
          text: this.$t("label_describe"),
          align: "start",
          value: "topic_description",
          sortable: false,
        },

        { text: "", value: "actions", sortable: false, align: "end" },
      ];
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-push-message-topic"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-push-message-topic"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-push-message-topic"),
          type: "del",
        },
      ];
    },
  },
  beforeDestroy() {},
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  watch: {
    $route(v) {
      if (v.name == "pushMessageTopic") {
        // console.log(v);
        this.getlist();
      }
    },
  },
  mounted() {
    // console.log(this.$route);
    this.getlist();
  },

  methods: {
    async getlist(obj) {
      this.loading = true;
      if (this.desserts.length == 1 && this.options.cpage != 1)
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;

        this.options = { ...this.options, ...obj };
      }
      const res = await getMessageTopicList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    turnPage({ cpage, pagesize }) {
      this.options.cpage = cpage;
      this.options.pagesize = pagesize;
      this.getlist();
    },
    addMessageTopic() {
      this.$store.commit("set_subPage_name", "");
      this.$store.commit("set_uuid", "");
      this.$store.commit("set_iconstatus", ""); //行内进图标显示
      this.$router.push({
        name: "addMessageTopic",
      });
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit("set_subPage_name", item.topic_name);
      this.$store.commit("set_uuid", item.uuid); //
      this.$router.push({
        name: "detailMessageTopic",
      });
    },
    handleClick({ index }, item) {
      switch (index) {
        case 0:
          this.godetail(item);
          break;
        case 1:
          this.$store.commit("set_subPage_name", item.topic_name);
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit("set_uuid", item.uuid); //
          this.$router.push({
            name: "detailMessageTopic",
          });
          break;
        case 2:
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteMessageTopicDetail({ uuids: item.uuid }).then((res) => {
              if (res.code === "200") {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (this.desserts.length == 1) this.options.cpage--;
                this.getlist();
              }
            });
          });
          break;
      }
    },
  },
};
</script>

